import { fetchBadges, fetchMyChallenges, markChallengesSeen } from '../net/challenges';
import type { ShiftSync } from '../net/shiftSync';
import type { Garage } from '../ui/screens/Garage';
import type { Me } from '../ui/screens/Me';
import type { Menu } from '../ui/screens/Menu';
import type { ChallengeFlow } from './challengeFlow';
import type { GarageController } from './garageController';

/** What the Garage screen can ask for; the controller does the work. */
export function garageActions(control: GarageController, close: () => void): ConstructorParameters<typeof Garage>[1] {
  return {
    equip: (kind, id, text) => control.equip(kind, id, text),
    buy: (kind, id, text) => void control.buy(kind, id, text),
    previewHorn: (id) => control.preview(id),
    close,
  };
}

/** Where the Me screen gets its badges and sent challenges from. */
export function meLoaders(sync: ShiftSync, menu: Menu, challenges: ChallengeFlow): ConstructorParameters<typeof Me>[1] {
  return {
    badges: () => fetchBadges(sync.key),
    challenges: async () => (await fetchMyChallenges(sync.key))?.challenges ?? null,
    seen: () => void markChallengesSeen(sync.key).then(() => menu.setUnseen(0)),
    copy: (code) => challenges.copy(code),
  };
}
